module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/greenery-be476d007edb5fa50404c0f46aac26df.jpg";